import { Tooltip, Avatar, Typography, Stack } from "@mui/material";
import { useTheme } from "@mui/material/styles";

export interface IApplicationAvatar {
  name?: string;
  description?: string;
  width?: string | number;
  height?: string | number;
  onlyAvatar?: boolean;
  logoLink?: string;
}

export const ApplicationAvatar: React.FC<IApplicationAvatar> = (props) => {
  const theme = useTheme();
  const { name, description, width = 42, height = 42, onlyAvatar, logoLink } = props;

  return (
    <Tooltip title={name} arrow>
      <Stack spacing={onlyAvatar ? 0 : 2} direction="row" data-testid="application-avatar" sx={{ alignItems: "center" }}>
        <Avatar
          sx={() => ({
            width: { width },
            height: { height },
            color: "#fff",
            borderRadius: theme.spacing(0.5),
          })}
          variant="rounded"
        >
          <img src={logoLink} alt="" />
        </Avatar>
        {!onlyAvatar && (
          <Stack>
            <Typography
              variant="body1"
              noWrap
              sx={{ color: theme.palette.primary.main, fontWeight: theme.typography.fontWeightSemiBold }}
            >
              {name}
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: theme.palette.grey[500],
              }}
            >
              {description}
            </Typography>
          </Stack>
        )}
      </Stack>
    </Tooltip>
  );
};
